import { Box, Button, Grid, IconButton } from "@mui/material";
import {useState} from "react";
import menu_icon from '../../../../../asset/image/menu_icon.svg';
import MenuIcon from '@mui/icons-material/Menu';
import "./MenuButton.css";

interface MenuButtonProps {
    menuItems?: string[];
    handleMenuItemClick?: (value: string) => void;
}

const MenuButton = (props: MenuButtonProps) => {
    const {menuItems, handleMenuItemClick} = props;
    const [menuOpen, setMenuOpen] = useState<boolean>(false);
    return (
        <div>
            <Grid item md={2} lg={2} className={menuOpen ? "l-shape filterBorder" : ''}>
                <Box className="filterButtonDiv" style={{ width: '100%', height: '100%' }}>
                    <Button
                        variant="outlined"
                        startIcon={<MenuIcon  sx={{width: 16, height: 16}}/>}
                        onClick={() => setMenuOpen(prev => !prev)}
                        className="filter-button"
                    >
                    </Button>
                </Box>
            </Grid>
            {menuOpen && <Box className="menuPopup">
                <Grid>
                    {menuItems?.map((val) => {
                        return <Button className="menuItemButton" onClick={() => handleMenuItemClick?.(val)}>{val}</Button>
                    })}
                </Grid>
            </Box>}
        </div>
    )
}

export default MenuButton;